import React, {useEffect, useState} from 'react';
import '../ChestPurchaseModal/ChestPurchaseModal.css';
import '../RatingCrystalsRewardModal/RatingCrystalsRewardModal.css';
import './AppInstallPromoModal.css';
import PageButton from '../../elements/PageButton/PageButton';
import {MaskedIcon, MASKED_ICON_TONES} from '../../coloredIcons/MaskedIcon/MaskedIcon';
import {getChestIconPath} from '../../../utils/inventory/getChestIconPath';
import {getChestDisplayName} from '../../../utils/inventory/getChestDisplayName';
import {APP_INSTALL_REWARD_CHEST_ID} from '../../../configs/appInstall';
import {MENU_SOUND_MANAGER} from '../../../scenes/MenuSoundManager';
import {sendPageEvent} from '../../../analytics/gameAnalytics';
import {getDeviceKind} from '../../../utils/device/getDeviceKind';

const PAGE_ID = 'AppInstallPromoModal';

/**
 * Предложение установить приложение — открывается кнопкой «Установить
 * приложение» в главном меню.
 *
 * Корпус и подсветка те же, что у модалки «Кристаллы за рейтинг»
 * (chest-purchase-* плюс rating-crystals-*), а вместо кристаллов показан
 * сундук, который игрок получит за первый вход через установленное приложение
 * (начисляет сервер, см. /api/users/me/app-install-reward).
 *
 * Кнопка «Установить» зовет системное окно установки перехваченным событием
 * beforeinstallprompt (см. utils/pwa/appInstall) — поэтому она и показывается
 * только там, где это событие вообще приходит.
 */
const AppInstallPromoModal = ({onInstall, onClose, isGuest}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    MENU_SOUND_MANAGER.playChestOpen();
    // Показ модалки: по нему считается воронка «увидел предложение ->
    // согласился на установку» (исход установки шлет главное меню)
    sendPageEvent(PAGE_ID, 'mount', getDeviceKind(), isGuest ? 'guest' : undefined);
    const showTimer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(showTimer);
  }, [isGuest]);

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => onClose?.(), 300);
  };

  const handleInstall = () => {
    onInstall?.();
    handleClose();
  };


  return (
    <div
      className={`chest-purchase-overlay rating-crystals-overlay ${visible ? 'chest-purchase-overlay_visible' : ''}`}
      role={'dialog'}
      aria-modal={'true'}
    >
      <div
        className={`chest-purchase-modal rating-crystals-modal ${visible ? 'chest-purchase-modal_visible' : ''}`}
      >
        <div className={'chest-purchase-content'}>
          <h2 className={'rating-crystals-modal_title app-install-promo-modal_title'}>Установи приложение</h2>

          <div className={'chest-purchase-image-wrapper'}>
            <img
              className={'chest-purchase-image'}
              src={getChestIconPath(APP_INSTALL_REWARD_CHEST_ID)}
              alt={getChestDisplayName(APP_INSTALL_REWARD_CHEST_ID)}
            />
          </div>

          <p className={'app-install-promo-modal_text'}>
            За первый вход через установленное приложение ты получишь <b>
              {getChestDisplayName(APP_INSTALL_REWARD_CHEST_ID)}
            </b>.
          </p>
          <p className={'app-install-promo-modal_text app-install-promo-modal_text_secondary'}>
            Приложение открывается с рабочего стола и работает на весь экран — без адресной строки браузера.
          </p>

          <div className={'main-menu-buttons chest-purchase-buttons'}>
            <PageButton onClick={handleInstall} pageId={PAGE_ID} buttonId={'install'} isGuest={isGuest}>
              <span className={'app-install-promo-modal_install-label'}>
                <MaskedIcon
                  className={'app-install-promo-modal_install-icon'}
                  src={'/img/icons/download.png'}
                  tone={MASKED_ICON_TONES.CONTROLS}
                  alt={'Установить'}
                />
                Установить
              </span>
            </PageButton>
            <PageButton
              className={'main-menu-button_secondary'}
              onClick={handleClose}
              pageId={PAGE_ID}
              buttonId={'close'}
              isGuest={isGuest}
            >
              Скрыть
            </PageButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppInstallPromoModal;
